export default class NumberHelper {
	static intValueOrNull(number) {
		if(number === undefined || number === null) {
			return null;
		}
		return Number.parseInt(number);
	}

	static getRatio(wins, losses, decimalPlaces = 1) {
		if(wins === undefined && losses === undefined) {
			return 0;
		}
		const total = wins + losses;
		if(total === 0) {
			return 0;
		}
		return Number((wins / (wins + losses) * 100).toFixed(decimalPlaces));
	}
}